






































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { CommonModule, UserModule } from '../../store'
import { enableOptions, userTypeOptions } from '../../utils/selectOptions'
import { CommonMixins } from '../../mixins/commonMixins'
import { SearchItemType, TableColumnItemType, OperationItemType, OptionItemType } from '../../types/type'
import { Pagination } from '../../mixins/pagination'
@Component({
  name: 'UserManagement',
  mixins: [CommonMixins, Pagination],
  components: {
    'check-strictly-choose-organation-ids': () => import('../../components/checkStrictlyChooseOrganationIds.vue'),
    'concise-card-have-title-acquiescent': () => import('../../components/common/conciseCardHaveTitleAcquiescent.vue'),
    'table-module': () => import('../../components/common/tableModule.vue'),
    'search-module': () => import('../../components/common/searchModule.vue'),
    'my-dialog': () => import('../../components/common/myDialog.vue')
  }
})
export default class UserManagement extends Vue {
  public tableDataList: any[] = []
  public currentPage: number = 1
  public pageSize: number = 10
  public total: number = 0
  public loading: boolean = true
  public dialogVisibleSetRole: boolean = false
  public whoEditorId: number | string = ''
  public isOnlyLook: boolean = false
  public roleList: any[] = []
  public roleOptions: any[] = []
  public userId: string | number = ''
  public dialogVisibleUpdatePassword: boolean = false
  public newPassword: string = ''
  public newPasswordAgain: string = ''
  public enableOptions: OptionItemType[] = enableOptions
  public userTypeOptions: OptionItemType[] = userTypeOptions
  // 搜索：
  public searchCheckList: Array<string> = []
  public searchList: Array<SearchItemType> = [
    {
      title: '用户名称',
      key: 'username',
      type: 'input',
      value: '',
      placeholder: '请输入用户名称',
      show: true,
      disabled: false
    },
    {
      title: '身份证号',
      key: 'card',
      type: 'input',
      value: '',
      placeholder: '请输入身份证身份证号',
      show: true,
      disabled: false
    },
    {
      title: '手机号',
      key: 'phone',
      type: 'input',
      value: '',
      placeholder: '请输入手机号',
      show: true,
      disabled: false
    },

    {
      title: '所属组织',
      key: 'organizationId',
      type: 'cascaderSpecial',
      value: '',
      placeholder: '请选择所属组织',
      treeData: [],
      show: true,
      disabled: false
    },
    {
      title: '是否启用',
      key: 'enable',
      type: 'select',
      value: '',
      placeholder: '请选择是否启用',
      selectOptions: [],
      show: true,
      disabled: false
    }
  ]
  // 列表列：
  public tableColumnList: Array<TableColumnItemType> = [
    {
      title: '用户名称',
      key: 'username',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    },
    {
      title: '身份证号',
      key: 'card',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    },
    {
      title: '手机号',
      key: 'phone',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    },
    {
      title: '所属组织',
      key: 'orgId',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      needTransformForResult: 'enum' // 值转换类型
    },
    {
      title: '单位名称',
      key: 'organizationName',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    },
    {
      title: '用户描述',
      key: 'descr',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    },
    {
      title: '用户类型',
      key: 'userType',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      // needTransformForResult: 'enum' // 值转换类型
      needTransformForResult: 'enum' // 值转换类型
    },
    {
      title: '账号状态',
      key: 'enable',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      needTransformForResult: 'enum' // 值转换类型
    }
  ]
  // 列操作：
  public columnOperationList: Array<OperationItemType> = [
    {
      title: '详情',
      key: 'detail',
      type: 'primary',
      size: 'mini'
    },
    {
      title: '编辑',
      key: 'update',
      type: 'primary',
      size: 'mini'
    },
    {
      title: '修改密码',
      key: 'updatePassword',
      type: 'warning',
      size: 'mini'
    },
    {
      title: '调整能访问的节点',
      key: 'bindOrganizationId',
      type: 'warning',
      size: 'mini'
    },
    {
      title: '角色分配',
      key: 'roleDistribution',
      type: 'warning',
      size: 'mini'
    },
    {
      title: '启用账号',
      key: 'enableTheAccountNumber',
      type: 'success',
      size: 'mini'
    },
    {
      title: '禁用账号',
      key: 'forbiddenTheAccountNumber',
      type: 'danger',
      size: 'mini'
    },
    {
      title: '删除',
      key: 'delete',
      type: 'danger',
      size: 'mini'
    }
  ]
  // 绑定可以访问的节点：
  public dialogVisibleBindOrganizationId: boolean = false
  public defaultProps: any = {
    children: 'children',
    label: 'name'
  }
  // 为了传递给自子组件：打开弹框的时候回显：
  public setCheckedNodesList: any[] = []
  public chooseOrganizationIdTitle: string = '绑定用户所能访问的节点'
  public administrativeOfficeList: OptionItemType[] = []

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get userInfoAuthority () {
    return UserModule.userInfo ? UserModule.userInfo.resultAuthorityList : []
  }

  get allRole () {
    let _that: any = this
    return _that.$RoleCode
  }

  @Watch('$route') routePathChange (newval, oldval) {
    let _that: any = this
    if (
      newval.path === '/index/UserManagement' &&
      oldval.path === '/index/AddOrUpdateUser'
    ) {
      if (
        newval.query.hasOwnProperty('refresh') &&
        newval.query.refresh === 'refresh'
      ) {
        this.getTableDataList()
      }
    }
    this.getRoleOptions()
  }

  async created () {
    await CommonModule.getTreeDataForSubOrganization()
    this.getRoleOptions()
    this.disposeSearchCheckedInit()
    this.disposeForSearchList()
    this.getTableDataList()
  }

  // 选择项初始化：
  disposeSearchCheckedInit () {
    // this.searchCheckList = this.searchList.length > 2 ? this.searchList.slice(0, 2).map(item => item.key) : this.searchList.slice(0).map(item => item.key)
    this.searchCheckList = this.searchList.slice(0).map(item => item.key)
  }

  // 选择项数据处理：
  disposeForSearchList (): void {
    this.searchList = this.searchList.map(item => {
      switch (item.key) {
        case 'organizationId':
          item.treeData = this.treeDataForSubOrganatizion
          break
        case 'enable':
          item.selectOptions = this.enableOptions
          break
      }
      return item
    })
  }

  formatterColumn (row, column, cellValue, index): string {
    let res = []
    switch (column.property) {
      case 'userType':
        res = this.userTypeOptions.filter(item => item.value == cellValue)
        break
      case 'position':
        res = this.administrativeOfficeList.filter(
          item => item.value == cellValue
        )
        break
    }
    return res.length && res[0].name ? res[0].name : '- -'
  }

  formatterColumnOfOrganizationId (row, column, cellValue, index) {
    let res
    var find = function (arr, id) {
      arr.some(item => {
        if (item.id == id) {
          res = item
          return item
        } else if (item.children && item.children.length > 0) {
          // 判断chlidren是否有数据
          find(item.children, id) // 递归调用
        }
      })
    }
    find(this.treeDataForSubOrganatizion, cellValue)
    return res ? res.name : '- -'
  }

  async getRoleOptions () {
    try {
      let _that: any = this
      let params = {
        pageNo: 1,
        pageSize: 1000
      }
      let { data: result } = await _that.$http.getRoleList(params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.roleOptions = (result.data && result.data.records) || []
    } catch (err) {
      console.log(err)
    }
  }

  addOneUser (id) {
    this.$router.push({ name: 'AddOrUpdateUser', query: { id } })
  }

  goDetail (item: any) {
    this.$router.push({
      name: 'AddOrUpdateUser',
      query: { id: item.id, readOnly: 'true' }
    })
  }

  editorDetail (item: any) {
    this.$router.push({ name: 'AddOrUpdateUser', query: { id: item.id } })
  }

  // 角色操作：
  async roleDistribution (item: any) {
    let _that: any = this
    this.dialogVisibleSetRole = true
    this.userId = item.id
    try {
      let { data: result } = await _that.$http.sysUserGetUserRoles({
        userId: this.userId
      })
      if (result.code !== 200) return this.$message.error(result.msg)
      this.roleList = result.data.map(item => item.id)
    } catch (err) {
      console.log(err)
    }
  }

  findOneByOrganizationId (id) {
    let res
    var find = function (arr, id) {
      arr.some(item => {
        if (item.id == id) {
          res = item
          return item
        } else if (item.children && item.children.length > 0) {
          find(item.children, id)
        }
      })
    }
    find(this.treeDataForSubOrganatizion, id)
    return res || {}
  }

  // 绑定用户所能访问的节点，回显：
  async bindOrganizationId (item: any) {
    let _that: any = this
    this.dialogVisibleBindOrganizationId = true
    this.userId = item.id
    try {
      let { data: result } = await _that.$http.sysUsergetUserOrganization({
        userId: this.userId
      })
      if (result.code !== 200) return this.$message.error(result.msg)
      // 处理：
      let resArr = []
      // 拿到的只包含了id,需要找到这一整项
      result.data.forEach(item => {
        let schoolItem = this.findOneByOrganizationId(item.organizationId)
        resArr.push(schoolItem)
      })
      // 传递给子组件：
      this.setCheckedNodesList = resArr
      // 调用子组件的方法：
      ;(this as any).$refs.refForCheckStrictlyChooseOrganationIds.dialogOpen(this.setCheckedNodesList)
    } catch (err) {
      console.log(err)
    }
  }

  async saveSetRole () {
    try {
      let _that: any = this
      let params = this.roleList.map(item => {
        item = {
          roleId: item,
          userId: this.userId
        }
        return item
      })
      let { data: result } = await _that.$http.sysUserAddRole(params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success('角色分配成功')
      this.dialogVisibleSetRole = false
      this.getTableDataList()
    } catch (err) {
      console.log(err)
    }
  }

  updatePassword (item: any) {
    this.userId = item.id
    this.dialogVisibleUpdatePassword = true
  }

  async savePassword () {
    try {
      let _that: any = this
      if (!this.newPassword) return this.$message.warning('请输入新密码')
      if (!this.newPasswordAgain) return this.$message.warning('请再次输入新密码')
      if (this.newPasswordAgain !== this.newPassword) return this.$message.warning('两次密码输入不一致')
      let params = {
        id: this.userId,
        newPassword: this.newPassword
      }
      let { data: result } = await _that.$http.sysUserAdminUpdatePassword(
        params
      )
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success('密码更新成功,将在下次登录生效')
      this.dialogVisibleUpdatePassword = false
      this.newPassword = this.newPasswordAgain = ''
      this.getTableDataList()
    } catch (err) {
      console.log(err)
    }
  }

  async enableChange (item: any) {
    let { enable } = item
    const confirmTitle = enable ? '确定要禁用此账号吗？' : '确定要启用此账号吗？'
    const messageTitle = enable ? '禁用成功' : '启用成功'
    try {
      this.$confirm(confirmTitle, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let _that: any = this
          let params = {
            id: item.id
          }
          let { data: result } = await _that.$http.sysUserEnable(params, {})
          if (result.code !== 200) return this.$message.error(result.msg)
          this.$message.success(messageTitle)
          this.getTableDataList()
        })
        .catch(() => {})
    } catch (err) {
      console.log(err)
    }
  }

  async deleteOfOne (item: any) {
    try {
      this.$confirm('确定要删除此用户吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      })
        .then(async () => {
          let _that: any = this
          let params = {
            id: item.id
          }
          let { data: result } = await _that.$http.delSysUserById(params)
          if (result.code !== 200) return this.$message.error(result.msg)
          this.$message.success('删除成功')
          this.getTableDataList()
        })
        .catch(() => {})
    } catch (err) {
      console.log(err)
    }
  }

  handleSizeChange (pageSize: number): void {
    this.pageSize = pageSize
    this.getTableDataList()
  }

  handleCurrentChange (currentPage: number): void {
    this.currentPage = currentPage
    this.getTableDataList()
  }

  async getTableDataList () {
    try {
      const _that: any = this
      this.loading = true
      const pageParams = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      }
      const checkedList = this.searchList.filter(item => {
        let checked = null
        this.searchCheckList.forEach(v => {
          if (item.key === v) checked = item
        })
        return checked
      })
      const searchParams = checkedList.reduce((result, current) => {
        let { key, value } = current
        if (value !== '') {
          switch (key) {
            case 'organizationId':
              const contentcopy = ((value || []) as any[]).map(item => item[item.length - 1])
              result[key] = contentcopy
              break
            default:
              result[key] = value
              break
          }
        }
        return result
      }, {})
      let { data: result } = await _that.$http.getSysUserList(
        pageParams,
        searchParams
      )
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.tableDataList = ((result.data && result.data.records) || []).map(item => {
        item['orgId'] = item.organizationId
        return item
      })
      this.total = result.data.total
    } catch (err) {
      console.log(err)
    }
  }

  resetBtn () {
    this.searchList = this.searchList.map(item => {
      item.value = ''
      return item
    })
  }

  searchBtn (searchCheckListSelf) {
    this.currentPage = 1
    this.pageSize = 10
    this.searchCheckList = searchCheckListSelf
    this.getTableDataList()
  }

  // 操作按钮：
  operationForButton ({ key }, row) {
    switch (key) {
      case 'detail':
        this.goDetail(row)
        break
      case 'update':
        this.editorDetail(row)
        break
      case 'updatePassword':
        this.updatePassword(row)
        break
      case 'bindOrganizationId':
        this.bindOrganizationId(row)
        break
      case 'roleDistribution':
        this.roleDistribution(row)
        break
      case 'enableTheAccountNumber':
      case 'forbiddenTheAccountNumber':
        this.enableChange(row)
        break
      case 'delete':
        this.deleteOfOne(row)
        break
    }
  }
}
